class QuizStep extends HTMLElement {
    constructor() {
        super();
        this.productID = [];
        this.sellingID = [];
        this.itemsForCart = [];
        this.curStep = this.querySelector('#current-step');
        this.quizAnswer = this.querySelectorAll(".quiz-answer");
        this.quizStep =this.querySelectorAll(".quiz-step");
        this.scriptTag = this.querySelectorAll('script[data-product]');
        this.subscriptionButtons = this.querySelectorAll('.quiz-subscription');
        this.modalButtons = this.querySelectorAll('.button-modal');
        this.selectedVariantValues = [];
        this.productVariantOptions = [];
        this.sellingPlanArray = [];
        this.selectedPlanID = '';
        this.selectedVariantID = '';
        this.init();
    }

    init() {
        this.updateStepIndicator(1, 5);
        this.addAnswerListeners();
        this.subscription();
        this.modalClick();
    }

    modalClick() {
        var _this = this;
        document.querySelectorAll('.button-modal').forEach(item => {
            item.addEventListener('click', function() {
                let modalButtonTitle = this.closest('.subscription-button--group').querySelector('.quiz-answer').textContent;
                if (modalButtonTitle == "Roaster's Choice") {
                    modalButtonTitle = "roaster";
                }
                const modalContent = this.closest('.subscription-button--group').querySelector(`input.${modalButtonTitle}`).dataset.moreinfo;   
                _this.querySelector('.modal').classList.add('active');
                _this.querySelector('.modal .modal-title').innerHTML = this.closest('.subscription-button--group').querySelector('.quiz-answer').textContent;  
                _this.querySelector('.modal .modal-text').innerHTML = modalContent;   
            })
        })
        this.querySelector('.modal__close').addEventListener('click', function() {
            document.querySelector('.modal').classList.remove('active');
        })
    }

    subscription() {
        var _this = this;
        this.subscriptionButtons.forEach(item => {
            item.addEventListener('click', function() {
                let planKey = item.getAttribute('data-date');
                _this.querySelector('.delivered').textContent = _this.sellingPlanArray.filter(item => item.name.includes(planKey)).map(item => item.name);
                _this.selectedPlanID = _this.sellingPlanArray.filter(item => item.name.includes(planKey)).map(item => item.id);
                _this.prepareCartItems();                        
            })
        })
    }

    updateStepIndicator(currentStep, totalSteps) {
        if (this.curStep) { 
            this.curStep.innerHTML = currentStep;
        } 
    }
    
    addAnswerListeners() {
        this.quizAnswer.forEach(item => {
            item.addEventListener("click", () => {   
                if (item.closest('.subscription-button--group')) {
                    document.querySelector('.brew').textContent = item.textContent;
                }
                let nextStep = item.getAttribute("data-next");
                let productID = item.getAttribute("data-id");
                if (this.scriptTag) {
                    this.scriptTag.forEach(item => {
                        const productData = JSON.parse(item.innerHTML);
                        const productId = productData.id;
                        let quizStep = 3;                
                        if (productId == productID) {
                            this.processProductOptions(productData, productData.options.length, quizStep);
                        }
                    });
                }
                if (nextStep != "results") {
                    this.showNextStep(nextStep);
                } 
            });
        });
    }

    processProductOptions(productData, step, quizStep) {
        const productSpecifiedOption = `option${step}`;
    
        if (!productData.variants) {
            return;
        }
    
        let variantOptionArray = [...new Set(productData.variants.map(item => item[productSpecifiedOption]))];
        let productTypeBtnHTML = '';
        const internalStep = quizStep + 1;       
    
        variantOptionArray.forEach(item => {
            productTypeBtnHTML += `
                    <div class="subscription-button--group">
                        <input type="hidden" class="Knockout" data-moreinfo="Our signature seasonal espresso. A well rounded, full bodied espresso, with flavours that you can trust.">
                        <input type="hidden" class="Decaffeinated" data-moreinfo="Single origin seasonal coffee, decaffeinated using organic natural water CO2 process.">
                        <input type="hidden" class="roaster" data-moreinfo="This may be a coffee from our existing range, something we are excited to share, a one-off micro lot, or a sample of a new coffee.">
                        <input type="hidden" class="Steadfast " data-moreinfo="This may be a coffee from our existing range, something we are excited to share, a one-off micro lot, or a sample of a new coffee.">

                        <button class="quiz-answer" data-tag="${item}" data-next="${internalStep}">${item}</button>
                        <div class="button-modal">
                            <svg width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M6 2C3.51472 2 1.5 4.01472 1.5 6.5C1.5 8.98528 3.51472 11 6 11C8.48528 11 10.5 8.98528 10.5 6.5C10.5 4.01472 8.48528 2 6 2ZM0.5 6.5C0.5 3.46243 2.96243 1 6 1C9.03757 1 11.5 3.46243 11.5 6.5C11.5 9.53757 9.03757 12 6 12C2.96243 12 0.5 9.53757 0.5 6.5Z" fill="#959595"/>
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M6 6C6.27614 6 6.5 6.22386 6.5 6.5V8.5C6.5 8.77614 6.27614 9 6 9C5.72386 9 5.5 8.77614 5.5 8.5V6.5C5.5 6.22386 5.72386 6 6 6Z" fill="#959595"/>
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M5.5 4.5C5.5 4.22386 5.72386 4 6 4H6.005C6.28114 4 6.505 4.22386 6.505 4.5C6.505 4.77614 6.28114 5 6.005 5H6C5.72386 5 5.5 4.77614 5.5 4.5Z" fill="#959595"/>
                            </svg>  
                            <span>more info</span>
                        </div>
                    </div>
                    `;
        });
        document.querySelector(`.quiz-step[data-step="${quizStep}"] .button-group`).innerHTML = productTypeBtnHTML;
        document.querySelectorAll(`.quiz-step[data-step="${quizStep}"] .button-group button`).forEach(item => {
            item.addEventListener('click', e => {
                const selectedTag = e.target.dataset.tag;
                this.productVariantOptions.push(selectedTag);
                const currentStep = step - 1;
                if (currentStep >= 0) {
                    this.handleNextStep(productData, currentStep, selectedTag, internalStep);
                }
            });
        });
        this.modalClick();
    }
    
    handleNextStep(productData, currentStep, selectedTag, internalStep) {
        const previousSpecifiedOption = `option${currentStep + 1}`;
        const productSpecifiedOption = `option${currentStep}`;
    
        let variantOptionArray = [...new Set(
            productData.variants.map(item => {
                return item[previousSpecifiedOption] === selectedTag ? item[productSpecifiedOption] : '';
            })
        )];
    
        const newFilterArray = variantOptionArray.filter(element => element !== "");
        let productTypeBtnHTML = '';
    
        newFilterArray.forEach(item => {
            productTypeBtnHTML += `<button class="quiz-answer" data-tag="${item}" data-next="${internalStep + 1}">${item}</button>`;
        });
    
        if (internalStep < 6) {
            document.querySelector(`.quiz-step[data-step="${internalStep}"] > .button-group`).innerHTML = productTypeBtnHTML;
            this.showNextStep(internalStep);
            this.processProductOptions(productData, currentStep, internalStep);
        } else {
            productData.variants.map(variant => {
                const variantOptionsArray = variant.title.split('/').map(item => item.trim());
                if (this.arraysAreEqualUnordered(variantOptionsArray, this.productVariantOptions)) {
                    this.selectedVariantID = variant.id;
                    // price
                    const variantPrice = new Intl.NumberFormat('en-GB', {
                        style: 'currency',
                        currency: 'GBP',
                    }).format(variant.price/100);
                    document.querySelector('.price').textContent = variantPrice;
                    // weight
                    document.querySelector('.weight').textContent = variant.weight + 'g';
                    // type
                    document.querySelector('.type').textContent = variant.option3;
                    // prep
                    document.querySelector('.prep').textContent = variant.option2;
                }
                this.sellingPlanArray = productData.selling_plan_groups[0].selling_plans;               
            })
            this.showNextStep(internalStep);
        }
    }

    arraysAreEqualUnordered(arr1, arr2) {
        if (arr1.length !== arr2.length) {
            return false;
        }
        const sortedArr1 = arr1.slice().sort();
        const sortedArr2 = arr2.slice().sort();
    
        for (let i = 0; i < sortedArr1.length; i++) {
            if (sortedArr1[i] !== sortedArr2[i]) {
                return false;
            }
        }    
        return true; // Arrays are equal
    }
    
    showNextStep(nextStep) {
        this.quizStep.forEach(step => step.classList.remove("active"));
        this.querySelector(`.quiz-step[data-step="${nextStep}"]`).classList.add("active");
        this.updateStepIndicator(nextStep, 5);
    }

    prepareCartItems() {
        this.itemsForCart.push({
            id: this.selectedVariantID,
            quantity: 1,
            selling_plan: this.selectedPlanID[0]
        });
        this.addToCart();
    }

    addToCart() {
        this.querySelector('.modal-last-step').classList.add('active');
        const addCartItemData = { items: this.itemsForCart };
        fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(addCartItemData)
        })
        .then(response => {
            return response.json();
            
        })
        .catch(err => {
            console.log("Error==>", err);
        });        
    }
}

customElements.define("quiz-step", QuizStep);

